import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 16 16"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M4.205 4.205a.7.7 0 0 1 .99 0L8 7.01l2.805-2.805a.7.7 0 1 1 .99.99L8.99 8l2.805 2.805a.7.7 0 1 1-.99.99L8 8.99l-2.805 2.805a.7.7 0 0 1-.99-.99L7.01 8 4.205 5.195a.7.7 0 0 1 0-.99"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
